$(function () {
    const slides = $('#banner-highlights > .banner-content');
    const bannerArrowLeft = $('#banner-arrow-left');
    const bannerArrowRight = $('#banner-arrow-right');
    const bannerContentList = $('#banner-content-list');
    let indexActivedSlide = 0;
    slides.eq(0).addClass('banner-content-active');
    slides.each(() => {
        bannerContentList.append('<div class="banner-content-list-item"></div>');
    });
    const bannerContentListItems = $('.banner-content-list-item');
    bannerContentListItems.eq(0).addClass('banner-content-list-item-active');

    bannerContentListItems.each(function (index) {
        $(this).on('click', () => {
            slides.eq(indexActivedSlide).removeClass('banner-content-active');
            bannerContentListItems.eq(indexActivedSlide).removeClass('banner-content-list-item-active');
            slides.fadeOut(1);
            slides.eq(index).css('display', 'block').hide().fadeIn(500);
            slides.eq(index).addClass('banner-content-active');
            bannerContentListItems.eq(index).addClass('banner-content-list-item-active');
            indexActivedSlide = index;
        });
    });
    /**
     * 
     * @param {'next'|'back'} direction 
     */
    function slider(direction) {
        slides.eq(indexActivedSlide).removeClass('banner-content-active');
        bannerContentListItems.eq(indexActivedSlide).removeClass('banner-content-list-item-active');
        slides.fadeOut(1);
        if (direction === 'next') {
            indexActivedSlide++;
        }
        if (direction === 'back') {
            indexActivedSlide--;
        }
        if (indexActivedSlide >= slides.length) {
            indexActivedSlide = 0;
        }
        if (indexActivedSlide < 0) {
            indexActivedSlide = slides.length - 1;
        }
        slides.eq(indexActivedSlide).css('display', 'block').hide().fadeIn(500);
        slides.eq(indexActivedSlide).addClass('banner-content-active');
        bannerContentListItems.eq(indexActivedSlide).addClass('banner-content-list-item-active');
    }

    const interval = setInterval(() => {
        slider('next');
    }, 5000);

    bannerArrowRight.click(() => {
        slider('next');
        clearInterval(interval);
    });

    bannerArrowLeft.click(() => {
        slider('back');
        clearInterval(interval);
    });

    window.addEventListener('beforeunload', () => {
        clearInterval(interval);
    });
});

